import React from 'react';
import { FormikProps } from 'formik';
import Select from 'react-select';

import { Maybe } from '@interfaces/graphql-typings';

import styles from './yearsOfExperienceStyles.scss';

const YearsOfExperience: React.FC<FormikProps<{
  minimum: {
    yearsOfExperienceMin: Maybe<number>;
    yearsOfExperienceMax: Maybe<number>;
  };
}>> = ({ setFieldValue, values }) => {
  const options = [1, 2, 3, 4, 5, 6, 7, 8].map(year => ({
    label: `${year} Year${year === 1 ? '' : 's'} of Experience`,
    value: year
  }));

  const { yearsOfExperienceMin, yearsOfExperienceMax } = values.minimum;

  return (
    <div className={styles.yearsOfExperience}>
      <label>
        From
        <Select
          isClearable
          isSearchable={false}
          onChange={option => setFieldValue('minimum.yearsOfExperienceMin', option?.value)}
          options={options.filter(({ value }) => value < (yearsOfExperienceMax || 8))}
          placeholder="No Minimum Experience Required"
          value={options.find(({ value }) => value === yearsOfExperienceMin)}
        />
      </label>
      <label>
        To
        <Select
          isClearable
          isSearchable={false}
          onChange={option => setFieldValue('minimum.yearsOfExperienceMax', option?.value)}
          options={options.filter(({ value }) => value > (yearsOfExperienceMin || 0))}
          placeholder="No Maximum Experience Required"
          value={options.find(({ value }) => value === yearsOfExperienceMax)}
        />
      </label>
    </div>
  );
};

export default YearsOfExperience;
